import { render, staticRenderFns } from "./AdminActionButtons.vue?vue&type=template&id=23aec8b1"
import script from "./AdminActionButtons.vue?vue&type=script&lang=js"
export * from "./AdminActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports